import { rankingData } from '@/mocks/homeData';

const changeIcon = (change: string) => {
  if (change === 'up') return { icon: 'ri-arrow-up-line', cls: 'text-green-500' };
  if (change === 'down') return { icon: 'ri-arrow-down-line', cls: 'text-red-400' };
  return { icon: 'ri-add-line', cls: 'text-accent-500' };
};

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            {rankingData.title}
          </h2>
          <p className="text-sm md:text-base text-foreground-500">{rankingData.subtitle}</p>
        </div>

        <div className="flex flex-col gap-3">
          {rankingData.items.map((item) => {
            const ci = changeIcon(item.change);
            return (
              <div
                key={item.rank}
                className="flex items-center gap-4 bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/60 hover:border-primary-200/60 transition-colors duration-200 cursor-pointer"
              >
                <div className={`w-10 h-10 rounded-lg flex items-center justify-center font-heading text-lg font-bold flex-shrink-0 ${
                  item.rank === 1
                    ? 'bg-primary-500 text-background-50'
                    : item.rank === 2
                    ? 'bg-accent-500 text-background-50'
                    : item.rank === 3
                    ? 'bg-secondary-500 text-background-50'
                    : 'bg-background-200 text-foreground-500'
                }`}>
                  {item.rank}
                </div>

                <div className="flex-1 min-w-0">
                  <h3 className="text-sm md:text-base font-medium text-foreground-800 truncate">
                    {item.title}
                  </h3>
                </div>

                <span className="text-xs px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 font-medium whitespace-nowrap flex-shrink-0">
                  {item.tag}
                </span>

                <span className="text-xs text-foreground-500 flex-shrink-0 hidden sm:block">
                  {item.views} 次观看
                </span>

                <span className={`flex items-center gap-0.5 text-xs flex-shrink-0 ${ci.cls}`}>
                  <i className={ci.icon}></i>
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}